import Select from '@material-ui/core/Select/Select';
import { useMemo, useId } from 'react';
import FormControl from '@material-ui/core/FormControl';
import { InputLabel } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';

export interface GlobalSelectProps {
  label: string;
  values: Record<string, string>;
  fields: string[];
  formData: any;
  onChange: (newFormData: any) => void;
}

export function GlobalSelect(props: GlobalSelectProps) {
  const { label, values, fields, formData, onChange } = props;
  const formId = useId();
  const valueList = fields.map(f =>
    (formData[f] as string)?.replace(`${f}_`, ''),
  );
  const value = valueList.every(e => e === valueList[0])
    ? valueList[0] || ''
    : '';
  const items = useMemo(
    () =>
      Object.entries(values).map(([v, l]) => ({
        label: l,
        value: v,
      })),
    [values],
  );
  const onSelect = (newValue: string) => {
    const newFormData = {};
    fields.forEach(f => {
      Object.assign(newFormData, { [f]: `${f}_${newValue}` });
    });
    onChange(newFormData);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id={formId}>{label}</InputLabel>
      <Select
        labelId={formId}
        value={value}
        label={label}
        onChange={event => onSelect(event.target.value as any)}
      >
        {items.map(i => (
          <MenuItem key={i.value} value={i.value}>
            {i.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
